import type {TranslateResult} from  "vue-i18n"
import {getExtension} from "@/utility/media/file"

export default class SelectOption<T> implements ISelectOption<T>{
	public readonly value: T
	public readonly text: string
	public readonly icon?: string
	public readonly disabled: boolean

	public get iconIsUrl(): boolean {
		return this.icon !== undefined && getExtension(this.icon) !== null
	}

	constructor(value: T, text: string | TranslateResult, icon?: string, disabled: boolean = false) {
		this.value = value
		this.text = text.toString()
		this.icon = icon
		this.disabled = disabled
	}

	public toString(): string {
		return this.text
	}

	public static createSimple(value: string): SelectOption<string> {
		return new SelectOption<string>(value, value)
	}
}

export interface ISelectOption<T> {
	readonly value: T
	readonly text: string
	readonly icon?: string
	readonly disabled: boolean
}
